import * as Immutable from 'seamless-immutable';
import {
  ISSUE_TRANSITION_POPUP_CHANGE,
} from '../actions';

const initialState = Immutable.from({
  isTransitionPopupOpen: false,
});

export default (state = initialState, action) => {
  switch (action.type) {
    case ISSUE_TRANSITION_POPUP_CHANGE:
      return state.merge({ isTransitionPopupOpen: action.payload });
    default:
      return state;
  }
};
